import { PDFDownloadLink } from '@react-pdf/renderer'
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GetApp } from '@mui/icons-material';

import Button from 'components/library/Button/Button';
import IbanPDF from './IbanPDF';

import styles from './Transfer.module.css';
import { IbanTransfer } from 'types/Iban';

const Iban = ({ transfer, name, t }: {
  transfer: IbanTransfer,
  name: string,
  t: (key: string, options?: Record<string, any>) => string;
}) => (
  <div className={styles.grid}>
    <p className={styles.title}>
      {t('payment.transfert.amount')} :
    </p>
    <p className={styles.text}>
      {`${transfer.display_bank_transfer_instructions.amount_remaining} ${transfer.display_bank_transfer_instructions.currency === 'eur' ? '€' : transfer.display_bank_transfer_instructions.currency}`}
    </p>
    <p className={styles.title}>
      {t('payment.transfert.bank')} :
    </p>
    <p className={styles.text}>
      {name || transfer.display_bank_transfer_instructions.financial_addresses[0].iban.account_holder_name}
    </p>
    <p className={styles.title}>
      {t('payment.transfert.iban')} :
    </p>
    <p className={styles.text}>
      {transfer.display_bank_transfer_instructions.financial_addresses[0].iban.iban.match(/.{1,4}/g)?.join('  ')}
    </p>
    <p className={styles.title}>
      {t('payment.transfert.bic')} :
    </p>
    <p className={styles.text}>
      {transfer.display_bank_transfer_instructions.financial_addresses[0].iban.bic}
    </p>
  </div>
);

export default function Transfer({ name, transfer }: { name: string, transfer: IbanTransfer }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <div className={styles.transfer}>
      <p>
        {t('payment.transfert.description', { name })}
        <PDFDownloadLink
          document={<IbanPDF transfer={transfer} t={t} name={name} />}
          className={styles.download}
          fileName="iban.pdf"
        >
          {
            ({ loading }) => (
              loading ? t('payment.transfert.ongoing') : (
                <>
                  <GetApp className={styles.icon} />
                  {t('payment.transfert.download')}
                </>
              )
            )
          }
        </PDFDownloadLink>
      </p>
      <Iban
        transfer={transfer}
        name={name}
        t={t}
      />
      <Button
        type="secondary"
        variant="fill"
        label={t('payment.transfert.doneButton')}
        onButtonClick={() => navigate(`/${id}/confirmation?type=transfer`)}
        className={styles.submit}
      />
    </div>
  );
}
